import { render } from "./TheScheme.vue?vue&type=template&id=7a065fd0&scoped=true"
import script from "./TheScheme.vue?vue&type=script&lang=js"
export * from "./TheScheme.vue?vue&type=script&lang=js"

import "./TheScheme.vue?vue&type=style&index=0&id=7a065fd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a065fd0"]])

export default __exports__